module.exports={close:"Kapat",error:"Hata",info:"Bilgiler",success:"Başarılı",warning:"Uyarı"};